import { render, staticRenderFns } from "./ComponentRouting.vue?vue&type=template&id=5ee4f473&scoped=true"
import script from "./ComponentRouting.vue?vue&type=script&lang=js"
export * from "./ComponentRouting.vue?vue&type=script&lang=js"
import style0 from "./ComponentRouting.vue?vue&type=style&index=0&id=5ee4f473&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee4f473",
  null
  
)

export default component.exports